<template>
  <WsVersion
    label="證照公版"
    :localeMode="true"
    :id="$route.params.id"
    :modelName="modelName"
    :fields="versionFields"
    :versionModelName="versionModelName"
    :showFields="showFields"
    :titleKey="'last_version.name'"
    :versionTimestampKey="versionTimestampKey"
    :editable="editable"
  ></WsVersion>
</template>

<script>
import model from "@/models/license_template";
export default {
  data: () => ({
    modelName: model.modelName,
    versionFields: model.fields.last_version.fields,
    versionModelName: model.versionModelName,
    versionTimestampKey: model.versionTimestampKey,
    editable: true,
    showFields: [
      "locales",
      "statitory_extension_period",
      "recommend_notify_period",
      "training_hours",
      "acts",
      "updated_at",
      "updated_admin"
    ],
  }),
};
</script>